import { render } from "./survivalreport.vue?vue&type=template&id=6878f400&scoped=true"
import script from "./survivalreport.vue?vue&type=script&lang=js"
export * from "./survivalreport.vue?vue&type=script&lang=js"

import "./survivalreport.vue?vue&type=style&index=0&id=6878f400&scoped=true&lang=css"
import "./survivalreport.vue?vue&type=style&index=1&id=6878f400&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6878f400"]])

export default __exports__